import { MapPin, Navigation, Phone } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import {
  ADDRESS_LINES,
  MAPS_DIRECTIONS,
  MAPS_EMBED,
  WA_DEFAULT,
  PHONE_CALL_TEL,
  PHONE_WHATSAPP_DISPLAY,
  PHONE_CALL_DISPLAY,
} from "./data";
import { WhatsAppIcon } from "./WhatsAppIcon";

export default function LocationSection() {
  return (
    <section id="visit" className="relative bg-ink py-24 lg:py-32" data-testid="location-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="mb-14">
          <Eyebrow>Find Us</Eyebrow>
          <SectionTitle>
            Visit Our <span className="text-edge">Showroom</span>
          </SectionTitle>
        </Reveal>

        <div className="grid gap-6 lg:grid-cols-5">
          <Reveal className="lg:col-span-2">
            <div
              className="clip-corner flex h-full flex-col border border-line bg-card p-8"
              data-testid="location-address-card"
            >
              <div className="mb-6 flex h-12 w-12 items-center justify-center border border-edge text-edge">
                <MapPin size={22} strokeWidth={1.8} />
              </div>
              <h3 className="font-display text-3xl font-extrabold uppercase tracking-wide text-white">
                Lift Edge Hercules Fitness Store
              </h3>
              <address className="mt-4 space-y-1 not-italic text-ash">
                {ADDRESS_LINES.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </address>

              <div className="mt-8 space-y-3 border-t border-line pt-6">
                <a
                  href={MAPS_DIRECTIONS}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="location-get-directions-btn"
                  className="clip-corner-sm flex items-center justify-center gap-2 bg-edge px-5 py-3.5 font-display text-base font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-edgehot"
                >
                  <Navigation size={16} />
                  Get Directions
                </a>
                <a
                  href={WA_DEFAULT}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="location-whatsapp-btn"
                  className="flex items-center justify-center gap-2 border border-line px-5 py-3.5 font-display text-base font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:border-wa hover:text-wa"
                >
                  <WhatsAppIcon className="h-4 w-4" />
                  WhatsApp — {PHONE_WHATSAPP_DISPLAY}
                </a>
                <a
                  href={`tel:${PHONE_CALL_TEL}`}
                  data-testid="location-call-btn"
                  className="flex items-center justify-center gap-2 border border-line px-5 py-3.5 font-display text-base font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:border-white hover:text-white"
                >
                  <Phone size={16} />
                  Call Now — {PHONE_CALL_DISPLAY}
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12} className="lg:col-span-3">
            <div className="clip-corner h-full min-h-[380px] overflow-hidden border border-line">
              <iframe
                title="Lift Edge Hercules Fitness Store — City Plaza, Sevoke Road, Siliguri"
                src={MAPS_EMBED}
                className="h-full min-h-[380px] w-full grayscale-[35%] contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="location-map-iframe"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
